import React, { useState, useRef, useEffect } from 'react';
import '../partials/SearchDropDown.scss';

const SearchDropDown = ({ options = [], placeholder = 'Select an option', onSelect, disabled=false }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [selected, setSelected] = useState(null);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredOptions = options.filter(opt =>
    opt.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (option) => {
    setSelected(option);
    setShowDropdown(false);
    setSearchTerm('');
    if (onSelect) onSelect(option);
  };

  return (
    <div className="search-dropdown position-relative" ref={dropdownRef}>
      <input
        type="text"
        className="form-control"
        placeholder={placeholder}
        value={selected || ''}
        disabled={disabled}
        readOnly
        onClick={() => {
          if (!disabled) setShowDropdown(!showDropdown);
        }}
      />

      {showDropdown && (
        <div className="dropdown-menu show w-100 p-2">
          <input
            type="text"
            className="form-control mb-2"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
          <ul className="list-unstyled mb-0">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((opt, idx) => (
                <li
                  key={idx}
                  className="dropdown-item"
                  onClick={() => handleSelect(opt)}
                >
                  {opt}
                </li>
              ))
            ) : (
              <li className="dropdown-item text-muted">No options found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchDropDown;
